<template>
    <div>
        <masternav/>
        <div class="container-fluid f1">
        <div class="spc">
            <div class="row">
            <div class="col-sm-6 mt-5">
                <h1 class="title1"><b-icon-check-circle class="h1 mb-0"></b-icon-check-circle> {{$t('modify.mod1')}}</h1>
                <span><strong>{{$t('modify.mod2')}}</strong> {{ reserve.reserva.id }}</span>
            </div>

            <div class="col-sm-6 mt-5">
                <img class="float-right" :src="reserve.reserva.auto.image.url_imagen" alt="">
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                <div class="card-body">
                    <div class="row cardpadding">
                        <div class="col-sm-6 borde">
                            <p class="titleDetails">{{$t('modify.mod3')}}</p>
                            <span>{{ reserve.reserva.retiro.nombre_web }}</span><br>
                            <span>{{ fecha_salida }}</span><br>
                        </div>
                        <div class="col-sm-6">
                            <p class="titleDetails">{{$t('modify.mod4')}}</p>
                            <span>{{ reserve.reserva.devolucion.nombre_web }}</span><br>
                            <span>{{ fecha_entrada }}</span><br>
                        </div>
                    </div>
                </div>
                </div>

                <div class="row mt-4">
                        <div class="col-sm-6">
                            <span>{{$t('modify.mod5')}} {{reserve.reserva.email}}</span>
                        </div>
                        <div class="col-sm-6">
                            <button class="btn btn-secondary float-right" data-toggle="modal" data-target="#cancelModal">{{$t('modify.mod6')}}</button>
                            <modalcancel :id="reserve.reserva.id"></modalcancel> 
                            <button @click="cargaReservaEdit({num_reserva:reserve.reserva.id, brand:3})" class="btn btn-success float-right mr-2">{{$t('modify.mod7')}}</button>
                        </div>
                </div>

            </div>
        </div>
        </div>
    </div>
    <div class="container-fluid mt-4">
        <div class="spc">
            <div class="row">
                <div class="col-sm-7">
                    <h2>{{$t('modify.mod8')}}</h2>

                    <h6>{{$t('modify.mod9')}}</h6>
                    <hr>
                    <span><strong>{{$t('modify.mod15')}}</strong> {{ reserve.reserva.nombres }} {{ reserve.reserva.apellido_paterno }} {{ reserve.reserva.apellido_materno }}</span><br>
                    <span><strong>{{$t('modify.mod16')}}</strong> {{ reserve.reserva.email }}</span><br>
                    <span><strong>{{$t('modify.mod17')}}</strong> {{ reserve.reserva.telefono }} / {{ reserve.reserva.celular }}</span><br>
                    <span><strong>{{$t('modify.mod18')}}</strong> 25+</span>

                    <br><br>

                    <h6>{{$t('stepnav.st3')}}</h6>
                    <hr>
                    <span><strong>{{$t('nueva_reserva.label_category')}}:</strong> {{ reserve.reserva.auto.categoria.categoria }}</span><br>
                    <ul>
                        <li>{{ reserve.reserva.auto.marca }} {{ reserve.reserva.auto.modelo }} {{$t('fleet.fl1')}}</li>
                        <li>{{ reserve.reserva.auto.transmision }}</li>
                    </ul>
                    <strong>{{$t('step5.st6')}}</strong><span class="float-right">US$ {{ parseFloat(reserve.detalle_calculo.detalle.tarifa).toFixed(2) }}</span><br>

                    <br><br>

                    <h6>Extras</h6>
                    <hr>

                    <span v-show="calculo.detalle.cob_obligatoria.monto[0] > 0">
                        {{ calculo.detalle.cob_obligatoria.nombre[0] }} <span class="float-right">US$ {{ parseFloat(calculo.detalle.cob_obligatoria.monto[0]).toFixed(2) }}</span> <br>
                    </span>

                    <span v-show="calculo.detalle.cob_obligatoria.monto[1] > 0">
                        {{ calculo.detalle.cob_obligatoria.nombre[1] }} <span class="float-right">US$ {{ parseFloat(calculo.detalle.cob_obligatoria.monto[1]).toFixed(2) }}</span> <br>
                    </span>

                    <span v-for="cobertura in data.coberturas" :key="cobertura.id">
                        {{ cobertura.nombre }} <span class="float-right">US$ {{ cobertura.monto }}</span> <br>
                    </span>

                    <span v-for="accesorio in data.accesorios" :key="accesorio.id">
                        {{ accesorio.nombre }} <span class="float-right">US$ {{ accesorio.monto }}</span> <br>
                    </span>
                    
                    <span class="spanXtras" v-show="data.conductor_adicional > 0">
                        {{$t('extras.drv2')}}
                        <span class="float-right">US$ {{ parseFloat(reserve.detalle_calculo.detalle.conductor_adicional * data.conductor_adicional).toFixed(2) }}</span>
                    </span>

                    <br><br>

                    <h6>{{$t('hovercard.t4')}}</h6>
                    <hr>
                    <span><strong>{{$t('hovercard.t5')}}</strong> <span class="float-right">US$ {{ parseFloat(reserve.detalle_calculo.detalle.apo_fee).toFixed(2) }}</span></span><br>
                    <span><strong>Subtotal</strong> <span class="float-right">US$ {{ parseFloat(reserve.detalle_calculo.detalle.subtotal).toFixed(2) }}</span></span><br>
                    <span><strong>{{$t('hovercard.t7')}}</strong> <span class="float-right">US$ {{ parseFloat(reserve.detalle_calculo.detalle.itbm).toFixed(2) }}</span></span><br>
                    

                    <br><br>

                    <span><strong>{{$t('hovercard.t8')}}</strong><span class="float-right" style="font-size:26px;">US$ {{ parseFloat(reserve.detalle_calculo.detalle.total).toFixed(2) }}</span></span>
                    <hr>
                    <span>{{$t('modify.mod13')}}</span>

                    <ul class="nav nav-tabs mt-5" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">{{$t('reserve_step1and2.pick_date_label')}}</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">{{$t('reserve_step1and2.return_date_label')}}</a>
                        </li>
                    </ul>
                        <div class="cajamap">
                            <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                            
                            <div class="row place">
                                <div class="col-sm-6">
                                    <span>{{ fecha_salida }}</span><br>
                                    <h5>{{ reserve.reserva.retiro.nombre_web }}</h5>
                                    <span>{{ reserve.reserva.retiro.telefono1 }}</span><br>
                                    <span>{{$t('location.loc8')}} {{reserve.reserva.retiro.horario_sem}}</span><br>
                                    <span>{{$t('location.loc9')}} {{reserve.reserva.retiro.horario_sabado}}</span><br>
                                    <span>{{$t('location.loc10')}} {{reserve.reserva.retiro.horario_domingo}}</span>
                                </div>
                                <div class="col-sm-6">
                                    <iframe 
                                        class="mt-3"
                                        :src="reserve.reserva.retiro.extras.url_mapa_enterprise" 
                                        frameborder="0"
                                        width="100%" 
                                        height="200" 
                                        ></iframe>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                            <div class="row place">
                                <div class="col-sm-6">
                                    <span>{{ fecha_entrada }}</span><br>
                                    <h5>{{ reserve.reserva.retiro.nombre_web }}</h5>
                                    <span>{{ reserve.reserva.retiro.telefono1 }}</span><br>
                                    <span>{{$t('location.loc8')}} {{reserve.reserva.devolucion.horario_sem}}</span><br>
                                    <span>{{$t('location.loc9')}} {{reserve.reserva.devolucion.horario_sabado}}</span><br>
                                    <span>{{$t('location.loc10')}} {{reserve.reserva.devolucion.horario_domingo}}</span>
                                </div>
                                <div class="col-sm-6">
                                    <iframe 
                                        class="mt-3"
                                        :src="reserve.reserva.devolucion.extras.url_mapa_enterprise" 
                                        frameborder="0"
                                        width="100%" 
                                        height="200" 
                                        ></iframe>
                                </div>
                            </div>
                        </div>
                        </div>
                        </div>

                </div>
                <div class="col-sm-5 mt-4">
                    <div class="card f1">
                        <div class="card-body">
                            <button @click="salir" class="btn btn-success btn-block">{{$t('nueva_reserva.titulo_paso1')}}</button>
                        </div>
                    </div>
                    <br>
                    <div class="card f1">
                        <div class="card">
                            <div class="card-body">

                                <h2 class="titledetails">{{$t('step5.st15')}}</h2>

                                <b-row>
                                    <b-col>
                                        <ul>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st16')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st17')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st18')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st19')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st20')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st20_1')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st20_2')}}</a></li>
                                        </ul>
                                    </b-col>
                                </b-row>
                                <!-- modal for policies -->
                                <div 
                                class="modal fade" 
                                id="policiesModal" 
                                tabindex="-1" 
                                aria-labelledby="policies-modal" 
                                aria-hidden="true">
                                  <div class="modal-dialog modal-xl">
                                    <div class="modal-content rounded-0">
                                      <div 
                                      class="modal-header rounded-0" 
                                      style="background-color:#169a5a;">
                                        <h5 class="modal-title modaltitle" id="policies-modal">{{$t('modalpolicy.pol1')}}</h5>
                                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                          <span aria-hidden="true">&times;</span>
                                        </button>
                                      </div>
                                      <div class="modal-body">
                                        <b-row>
                                          <b-col md="5">
                                              <div style="margin-top:-17px"  class="nav flex-column " id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                                <a class="btnpolicies nav-link active" id="v-pills-1-tab" data-toggle="pill" href="#v-pills-1" role="tab" aria-controls="v-pills-1" aria-selected="true">
                                                  <p class="ml-3">{{$t('modalpolicy.pol2')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-2-tab" data-toggle="pill" href="#v-pills-2" role="tab" aria-controls="v-pills-2" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol3')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-3-tab" data-toggle="pill" href="#v-pills-3" role="tab" aria-controls="v-pills-3" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol5')}} 
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-4-tab" data-toggle="pill" href="#v-pills-4" role="tab" aria-controls="v-pills-4" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol7')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-5-tab" data-toggle="pill" href="#v-pills-5" role="tab" aria-controls="v-pills-5" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol9')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-6-tab" data-toggle="pill" href="#v-pills-6" role="tab" aria-controls="v-pills-6" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol11')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-7-tab" data-toggle="pill" href="#v-pills-7" role="tab" aria-controls="v-pills-7" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol13')}}
                                                  </p>
                                                </a>
                                              </div>
                                          </b-col>
                                          <b-col md>
                                            <div class="tab-content" id="v-pills-tabContent">
                                              <div class="tab-pane fade show active" id="v-pills-1" role="tabpanel" aria-labelledby="v-pills-1-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol2')}}</p>
                                                <renttermscomp/>
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-2" role="tabpanel" aria-labelledby="v-pills-2-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol3')}}</p>
                                               {{$t('modalpolicy.pol4')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-3" role="tabpanel" aria-labelledby="v-pills-3-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol5')}} </p>
                                                {{$t('modalpolicy.pol6')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-4" role="tabpanel" aria-labelledby="v-pills-4-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol7')}}</p>
                                                {{$t('modalpolicy.pol8')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-5" role="tabpanel" aria-labelledby="v-pills-5-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol9')}}</p>
                                                {{$t('modalpolicy.pol10')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-6" role="tabpanel" aria-labelledby="v-pills-6-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol11')}}</p>
                                                {{$t('modalpolicy.pol12')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-7" role="tabpanel" aria-labelledby="v-pills-7-tab">
                                                <p
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol13')}}</p>
                                                {{$t('modalpolicy.pol14')}}
                                              </div>
                                            </div>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import masternav                from '@/components/masternav.vue'
import { mapActions, mapState } from 'vuex'
import loader                   from '@/components/loader.vue'
import moment                   from 'moment'
import modalcancel    from '@/components/ModalCancelReserve'
import renttermscomp      from '@/components/renttermscomp.vue'
import { useGtm } from '@gtm-support/vue2-gtm';

    export default {
        name:'reserveFinalStep',
        metaInfo: {
        title: "Enterprise Panama - Final Reserva | Alquiler de Autos",
        meta: [
            {
            vmid: 'A',
            name: 'description',
            content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
            },
            {
            vmid: 'B',
            name: 'keywords',
            content: 'Enteprise panama, Enterprise rent a car, enterprise renta car, ALAMO, ENTERPRISE PANAMA, ALAMO PANAMA'
            }
        ]
        },
        components: {
            masternav,
            loader,
            modalcancel,
            renttermscomp
        },
        mounted () {
            if(this.confirmado == false)
            {
                this.$router.push({path:"/"})
            } 
            this.purchaseGtm()
        },
        computed: {
            ...mapState('reservav2', ['confirmado', 'data', 'calculo', 'reserve']),
            fecha_salida()
            {
                return moment(this.data.fecha_salida).format('LLLL')
            },
            fecha_entrada()
            {
                return moment(this.data.fecha_entrada).format('LLLL')
            },
        },
        methods: {
            salir() {
                
                this.$router.push({name:'Home'})
            },
            ...mapActions('reserva', ['modificarReserva']),
            ...mapActions('reservav2', ['cargaReservaEdit']),

            purchaseGtm(){
            var products = [
                 {
                   'name': this.reserve.reserva.auto.modelo,                                     //CD11
                   'id': this.reserve.reserva.auto.id, 
                   'brand': this.reserve.reserva.auto.marca,                              //CD15
                   'category': this.reserve.reserva.auto.titulo_vehiculo, 
                                                // Category/Category2/Category3 
                   'list': 'Vehículos | Selecciona el tipo de vehículos',
                   'index': 1,
                   'price': this.reserve.reserva.tarifa, 
                   'coupon': '',
                //Custom dimensions at product level
                   'extras': '',  //CD16
                   'prepay_price': '',                                  //CM02
                   'pay_destination': '',                               //CM03
                //Reserve. Custom dimensions at product level
                         'pick_up_location':  this.reserve.reserva.retiro.direccion,//CD04 
                         'drop_off_location': this.reserve.reserva.devolucion.direccion,//CD05  
                         'pick_up_date' : this.reserve.detalle_calculo.reserva.fecha_ret,            //CD06 
                         'pick_up_time' : this.reserve.detalle_calculo.reserva.hora_ret,                              //CD07           
                         'drop_off_date' : this.reserve.detalle_calculo.reserva.fecha_dev,            //CD08
                         'drop_off_time' : this.reserve.detalle_calculo.reserva.hora_dev,                          //CD09
                         'confirmation_number': this.reserve.reserva.auto.id,                        //CD10                       
                         'transmission_type': this.reserve.reserva.auto.transmission,                          //CD12 
                         'age': this.reserve.reserva.edad_arrendatario,                                            //CD14
                         'promotional_code': '',                       //CD18     
                         'number_of_passengers':  this.reserve.reserva.auto.capacidad,                  //CD19      
                         'codigo_vehiculo': this.reserve.reserva.auto.id,              //CD20     
                         'booking_days': this.reserve.detalle_calculo.reserva.cant_dias,                                      //CM01
                         'airport_fee': this.reserve.detalle_calculo.detalle.apo_fee,                              //CM04 
                         'base_rate': this.reserve.detalle_calculo.detalle.tarifa,                                 //CM05
                         'vehicle_license_fee': '',                        //CM06 
                }]
            var obj2=[];
                var obj3=[];
                var obj = this.data.coberturas
                var obj_1 = this.data.accesorios
          
                var obj2 = obj.map((obj,i,a )=> ({
                      name: obj.nombre,
                      id: obj.sigla,
                      list_id: obj.sigla,
                      list_name: 'covers' ,
                      index: i,
                      price: obj.monto,
                      quantity: '1'
                }))

                var obj3 = obj_1.map((obj_1,i,a )=> ({
                      name: obj_1.nombre,
                      id: obj_1.sigla,
                      list_id: obj_1.sigla,
                      list_name: 'accesories' ,
                      index: i,
                      price: obj_1.monto,
                      quantity: '1'
                }))

                Array.prototype.push.apply(products, obj2);
                Array.prototype.push.apply(products, obj3);
            /* --------------------------------------------------------------------------------------- */
            let gtm = useGtm();

            gtm.trackEvent({
              'event': 'purchase',
              'category' : 'ecommerce',              //Static data
              'action' : 'purchase',                 // Static data
              'label' : this.reserve.reserva.id,     // Dynamic data. Transaction ID
              
             //Transaction information
              'transaction': {
                        'transaction_id': this.reserve.reserva.id, // Transaction ID
                        'affiliation': 'Online',
                        'revenue': this.reserve.detalle_calculo.detalle.total,             //Total (incl. tax y shipping)
                        'tax': this.reserve.detalle_calculo.detalle.itbm,                   
                        'shipping': '',
                        'discount': '',
                        'coupon': '',
                        'coupon_amount': '',
                        'currencyCode': 'USD',
                        'payment_type': 'Reserva',                   //CD13
                        'card_type': this.reserve.reserva.formapago.forma_pago,   
                },
            
             //Enhanced Ecommerce - UA
              'ecommerce': {
                
                'purchase':{
                      'actionField': {
                        'step': 5, 
                        'option': 'purchase',},
                        'transaction_id': this.reserve.reserva.id, // Transaction ID
                        'affiliation': 'Online',
                        'revenue': this.reserve.detalle_calculo.detalle.total,             //Total (incl. tax y shipping)
                        'tax': this.reserve.detalle_calculo.detalle.itbm,                    
                        'shipping': '',
                        'discount': '',
                        'coupon': '',
                        'coupon_amount': '',
                        'currencyCode': 'USD',
                        'payment_type': 'Reserva',                   //CD13
                        'card_type': this.reserve.reserva.formapago.forma_pago,                               
                       },
                'products': products
                },
            });
        }
        },
        
    }
</script>

<style lang="scss" scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}

@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.btnpolicies{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 14px;
  background-color: #f3f3f3; /*  background */
  color: #169A5A !important; /*  text */
  cursor: pointer !important; /* Pointer/hand icon */
  border: none;
  width: 100% !important; /* Set a width if needed */
  height: 41px;
  display: block; /* Make the buttons appear below each other */
  margin-left: -16px;
  border-bottom: 1px solid #a3a4a5 !important;
  background: url("/img/arrowright.png") no-repeat right/10px ;
}
.btnpolicies .btnpolicies:not(:last-child) {
  border-bottom: none; /* Prevent double borders */
}

/* Add a background color on hover */
.btnpolicies:active {
  background-color: #15804d;
}
.btnpolicies:focus {
  background-color: #006639;
  outline: none !important;
  color: #fff !important;
}
.btnModificar{
    color: #169a5a;
    cursor: pointer;
}
.modaltitle{
  font-family: 'DIN 2014-Regular';
  font-size: 16px;
  color: #fff;
}
.f1{
    background-color: #F7F7F7;
    font-family: 'DIN 2014-Regular';
    
}
.spc{
    margin-left: 12%;
    margin-right: 12%;
    padding: 0px 0px 43px 0px;
}
h1,h2,h6, h5
{
    font-family: 'DIN 2014-ExraBold';
}
span, a
{
   font-family: 'DIN 2014-Regular';
}
.titleDetails
{
    font-family: 'DIN 2014-ExraBold';
}
.title1
{
    padding: 0px 0px 0px 0px;
}
.borde
{
    border-right: 1px solid rgba(0, 0, 0, 0.1);
}

.cardpadding
{
    padding: 2%;
}

.btn
{
    border-radius: 0%;
}

.cajamap
{
   border-left: 1px solid rgba(0, 0, 0, 0.1);
   border-right: 1px solid rgba(0, 0, 0, 0.1);
   border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.nav-tabs .nav-link
{
    border-radius: 0%;
}

.place
{
    padding: 4%;
}
.color-link{
    color: #169a5a;
}
</style>